module.exports = __webpack_public_path__ + "img/front_4.7b6f4ee3.svg";